module.exports = __webpack_public_path__ + "static/media/fly0232.55ecaf3f.webp";